import React, { Component } from 'react';
import language from '../../assets/languages/language';
import App_data from '../config/App_data';

class VideoValidateReportIcons extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    let {
      moveToNotes,
      notesCSS,
      moveToPracticeQuestions,
      _saveFavVideo,
      _displayReportForm,
      viewPdf,
      showFreePremium,
      bookmarkCSS,
      bookmarkColor,
      type,
      questionsCSS,
      saveVideo_text,
      currentReading,
      chapters,
      video,
      noPDFInExam,
      reportVideoTooltip = '',
      pdfFile = '',
    } = this.props;
    return (
      <div className='row'>
        <div className='col-sm-12'>
          {' '}
          <span className='d-inline-flex align-items-center'>
            {type === 'intro' ||
            (chapters && chapters[0].chapter_id === 11) ||
            (chapters && chapters[0].chapter_id === 12) ||
            !notesCSS ? null : (
              <span
                className='up tooltip-hover-questions'
                style={{ padding: '10px' }}
              >
                <div className='tootip_box'> {language.LC().GO_TO_NOTES} </div>
                <i
                  onClick={moveToNotes ? moveToNotes.bind('123') : null}
                  className={notesCSS}
                  style={{ color: '#1f8ceb' }}
                >
                  {' '}
                </i>
              </span>
            )}{' '}
            {type === 'intro' ||
            (chapters && chapters[0].chapter_id === 11) ||
            (chapters && chapters[0].chapter_id === 12) ? null : (
              <span
                className='up tooltip-hover-questions'
                style={{ padding: '10px' }}
              >
                <div className='tootip_box'>
                  {' '}
                  {language.LC().GO_TO_QUESTION_BANK}{' '}
                </div>
                <i
                  onClick={moveToPracticeQuestions.bind('123')}
                  className={questionsCSS}
                  style={{ color: '#1d364b' }}
                >
                  {' '}
                </i>
              </span>
            )}
            {type === 'intro' ? null : (
              <span
                className='up tooltip-hover-questions'
                style={{ padding: '10px' }}
              >
                <div className='tootip_box'> {saveVideo_text} </div>
                <i
                  onClick={_saveFavVideo.bind(this, currentReading)}
                  className={bookmarkCSS}
                  style={{ color: bookmarkColor }}
                >
                  {' '}
                </i>
              </span>
            )}
            <span
              className='up tooltip-hover-questions vertical-align-middle'
              style={{ padding: '10px' }}
            >
              <div className='tootip_box'>
                {' '}
                {console.log(
                  'checking the tooltip text',
                  reportVideoTooltip

                  // ,'===>',
                  // language.LC().REPORT_THIS_QUESTION
                )}
                {reportVideoTooltip
                  ? reportVideoTooltip
                  : language.LC().REPORT_THIS_QUESTION}{' '}
              </div>
              <div
                className='report-icon-wrapper'
                onClick={_displayReportForm.bind()}
              >
                <img
                  src={App_data.frontend_url + '/img/report4.png'}
                  alt='report'
                />
              </div>
            </span>
          </span>
          {noPDFInExam ? null : (
            <div onClick={() => viewPdf(pdfFile || video.pdf_file)} className='status-download-btn'>
              <a className='btn btn-primary  pointer_class pull-right'>
                <i className='fa fa-download  ' aria-hidden='true' />
                {showFreePremium ? (
                  <div className='premium-download'>
                    {language.LC().PREMIUM}
                  </div>
                ) : null}
                {language.LC().Download_PDF}
              </a>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default VideoValidateReportIcons;



// WEBPACK FOOTER //
// ./src/views/Common/VideoValidateReportIcons.js